/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconChevronRight from './nav-icon-chevron-right.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconChevronRight {...validProps} />;
}
SvgComponent.iconName = 'navIconChevronRight';

export const NavIconChevronRightIcon = svgIconWrapper(SvgComponent);
